<div class="order-details__list-item">
  <div class="detail-left-col">
    {{ 'FRONTEND.SALES_UI.CONTRACT_LENGTH' | translate }}
  </div>
  <div class="order-details__list-item__value">
    <div class="item_container">
      <ng-container *ngIf="isEditing; else display">
        <div class="contract-form" [formGroup]="contractDurationForm">
          <div class="row row-gutters">
            <div class="col col-xs-12 col-sm-6">
              <glxy-form-field>
                <glxy-label>{{ 'FRONTEND.SALES_UI.LENGTH' | translate }}</glxy-label>
                <input
                  matInput
                  formControlName="value"
                  [(ngModel)]="contractDuration.value"
                  (ngModelChange)="convertDuration()"
                />
              </glxy-form-field>
            </div>
            <div class="col col-xs-12 col-sm-6">
              <glxy-form-field>
                <glxy-label>{{ 'FRONTEND.SALES_UI.PERIOD' | translate }}</glxy-label>
                <mat-select
                  formControlName="duration"
                  [(ngModel)]="contractDuration.duration"
                  (ngModelChange)="convertDuration()"
                >
                  <mat-option *ngFor="let period of contractPeriods" [value]="period.value">
                    {{ period.key | translate }}
                  </mat-option>
                </mat-select>
              </glxy-form-field>
            </div>
          </div>

          <glxy-hint>
            {{ 'FRONTEND.SALES_UI.DURATION_WARNING' | translate }}
          </glxy-hint>

          <glxy-error *ngIf="invalidDurationValue()">
            {{ 'FRONTEND.SALES_UI.NUMBER_HIGHER_THAN' | translate: { minNumber: 0 } }}
          </glxy-error>
        </div>

        <button mat-flat-button color="primary" (click)="updateContractDuration()">
          <glxy-button-loading-indicator [isLoading]="updating">
            {{ 'FRONTEND.SALES_UI.SAVE' | translate }}
          </glxy-button-loading-indicator>
        </button>
      </ng-container>
    </div>
  </div>
</div>
<ng-template #display>
  <span class="duration">{{ contractDurationText$ | async }}</span>
  <button *ngIf="editable" mat-icon-button (click)="edit()">
    <mat-icon>edit</mat-icon>
  </button>
</ng-template>
